@file:OptIn(InternalResourceApi::class)

package eu.codlab.blipya.common_sub_login.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/eu.codlab.blipya.common_sub_login.generated.resources/"

@delegate:ResourceContentHash(-1_133_221_135)
internal val Res.string.app_login_sub_title: StringResource by lazy {
      StringResource("string:app_login_sub_title", "app_login_sub_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 10, 63),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 10, 63),
      ))
    }

@delegate:ResourceContentHash(345_065_661)
internal val Res.string.app_register_sub_title: StringResource by lazy {
      StringResource("string:app_register_sub_title", "app_register_sub_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 74, 58),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 74, 58),
      ))
    }

@delegate:ResourceContentHash(-2_074_309_952)
internal val Res.string.app_sub_title: StringResource by lazy {
      StringResource("string:app_sub_title", "app_sub_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 133, 33),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 133, 33),
      ))
    }

@delegate:ResourceContentHash(18_713_781)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 167, 26),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 167, 22),
      ))
    }

@delegate:ResourceContentHash(-1_164_924_713)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 194, 27),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 190, 27),
      ))
    }

@delegate:ResourceContentHash(-1_539_253_594)
internal val Res.string.create_account_title: StringResource by lazy {
      StringResource("string:create_account_title", "create_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 222, 60),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 218, 56),
      ))
    }

@delegate:ResourceContentHash(-996_968_000)
internal val Res.string.form_confirmation: StringResource by lazy {
      StringResource("string:form_confirmation", "form_confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 283, 41),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 275, 41),
      ))
    }

@delegate:ResourceContentHash(1_012_814_592)
internal val Res.string.form_email: StringResource by lazy {
      StringResource("string:form_email", "form_email", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 325, 26),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 317, 26),
      ))
    }

@delegate:ResourceContentHash(286_218_685)
internal val Res.string.form_password: StringResource by lazy {
      StringResource("string:form_password", "form_password", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 352, 37),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 344, 33),
      ))
    }

@delegate:ResourceContentHash(-302_846_680)
internal val Res.string.homepage_title_1: StringResource by lazy {
      StringResource("string:homepage_title_1", "homepage_title_1", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 390, 40),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 378, 40),
      ))
    }

@delegate:ResourceContentHash(1_421_892_983)
internal val Res.string.homepage_title_2: StringResource by lazy {
      StringResource("string:homepage_title_2", "homepage_title_2", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 431, 40),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 419, 40),
      ))
    }

@delegate:ResourceContentHash(-450_747_241)
internal val Res.string.homepage_title_3: StringResource by lazy {
      StringResource("string:homepage_title_3", "homepage_title_3", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 472, 48),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 460, 48),
      ))
    }

@delegate:ResourceContentHash(242_973_047)
internal val Res.string.login_account_title: StringResource by lazy {
      StringResource("string:login_account_title", "login_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 521, 39),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 509, 35),
      ))
    }

@delegate:ResourceContentHash(-1_760_154_920)
internal val Res.string.register_account_title: StringResource by lazy {
      StringResource("string:register_account_title", "register_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 561, 38),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 545, 42),
      ))
    }

@delegate:ResourceContentHash(868_434_827)
internal val Res.string.unexpected_error: StringResource by lazy {
      StringResource("string:unexpected_error", "unexpected_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/locales.commonMain.cvr", 600, 32),
        ResourceItem(setOf(), "${MD}values/locales.commonMain.cvr", 588, 48),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_login_sub_title", Res.string.app_login_sub_title)
  map.put("app_register_sub_title", Res.string.app_register_sub_title)
  map.put("app_sub_title", Res.string.app_sub_title)
  map.put("cancel", Res.string.cancel)
  map.put("confirm", Res.string.confirm)
  map.put("create_account_title", Res.string.create_account_title)
  map.put("form_confirmation", Res.string.form_confirmation)
  map.put("form_email", Res.string.form_email)
  map.put("form_password", Res.string.form_password)
  map.put("homepage_title_1", Res.string.homepage_title_1)
  map.put("homepage_title_2", Res.string.homepage_title_2)
  map.put("homepage_title_3", Res.string.homepage_title_3)
  map.put("login_account_title", Res.string.login_account_title)
  map.put("register_account_title", Res.string.register_account_title)
  map.put("unexpected_error", Res.string.unexpected_error)
}
